export * from "./home";
export * from "./exercise";
export * from "./myscores";
export * from "./scores";
export * from "./addcomment";
export * from "./comments";
export * from "./oops";
